import { Typography } from '@mui/material';
import DownloadSection from './DownloadSection';
import InstallationInstructions from './InstallationInstructions';


const DownloadsPage: React.FC = () => {


    return (
        <div>
            <Typography variant="h5" component="h2" className='page-title'>App Download</Typography>
            <DownloadSection />
            <div style={{ margin: '20px 0' }} />
            <InstallationInstructions />
        </div>
    );
};

export default DownloadsPage;